"use client"

import { useState } from "react"
import "./PasswordModal.css"

const PasswordModal = ({ isOpen, onSubmit, onClose, isLoading, error }) => {
  const [password, setPassword] = useState("")

  const handleSubmit = (e) => {
    e.preventDefault()
    if (password.trim()) {
      onSubmit(password)
    }
  }

  const handleKeyPress = (e) => {
    if (e.key === "Escape") {
      onClose()
    }
  }

  if (!isOpen) return null

  return (
    <div className="password-modal-overlay">
      <div className="password-modal">
        <div className="password-modal-header">
          <h3>🔒 Password Required</h3>
          <button onClick={onClose} className="close-btn">
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} className="password-modal-content">
          <p>This list is password protected. Please enter the password to continue.</p>

          {error && <div className="error-message">{error}</div>}

          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={handleKeyPress}
            placeholder="Enter password..."
            className="password-input"
            autoFocus
            disabled={isLoading}
          />

          <div className="password-modal-actions">
            <button type="submit" disabled={!password.trim() || isLoading} className="unlock-btn">
              {isLoading ? "Checking..." : "Unlock List"}
            </button>
            <button type="button" onClick={onClose} className="cancel-btn">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default PasswordModal
